// Minimised cart pill behaviour (2026-08-29).
//
// The pill itself is Liquid-rendered by kd-cart-minibar.liquid and hidden
// via CSS while the drawer dialog is open. This module only has to:
//   1. reopen the drawer when the pill is tapped (delegated, so a morph
//      replacing the button never drops the listener), and
//   2. re-sync count / message / fill / thumbnail after cart mutations,
//      because the drawer's inner component morphs but the pill markup is
//      not guaranteed to be in the morph root.
//
// The message and fill are mirrored from the drawer's own Liquid-rendered
// offer bar (#kd-offer-msg / #kd-offer-fill) rather than recomputed:
// /cart.js does not expose product tags, and mirroring guarantees the two
// surfaces can never disagree.

document.addEventListener('click', (event) => {
  const pill = event.target.closest('#kd-minibar');
  if (!pill) return;
  const drawer = document.getElementById('cart-drawer');
  if (drawer && typeof drawer.open === 'function') drawer.open();
});

let kdMinibarTimer = null;

async function kdMinibarSync() {
  const pill = document.getElementById('kd-minibar');
  if (!pill) return;

  let cart;
  try {
    cart = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`).then((r) => r.json());
  } catch {
    return;
  }

  if (!cart.item_count) {
    pill.hidden = true;
    return;
  }
  pill.hidden = false;

  const count = document.getElementById('kd-minibar-count');
  if (count) count.textContent = cart.item_count;

  const latest = cart.items[0];
  const thumb = document.getElementById('kd-minibar-thumb');
  if (thumb && latest?.image) {
    const src = `${latest.image}${latest.image.includes('?') ? '&' : '?'}width=96`;
    if (thumb.src !== src) thumb.src = src;
  }

  const drawerMsg = document.getElementById('kd-offer-msg');
  const msg = document.getElementById('kd-minibar-msg');
  if (drawerMsg && msg) msg.textContent = drawerMsg.textContent.trim();

  const drawerFill = document.getElementById('kd-offer-fill');
  const fill = document.getElementById('kd-minibar-fill');
  if (fill) fill.style.width = drawerFill ? drawerFill.style.width : '0%';
}

// Observe the drawer only, NOT the whole section wrapper: the pill lives in
// the wrapper, and watching its own sync writes would loop the observer.
const kdMinibarRoot = document.getElementById('cart-drawer');
if (kdMinibarRoot) {
  new MutationObserver(() => {
    clearTimeout(kdMinibarTimer);
    kdMinibarTimer = setTimeout(kdMinibarSync, 150);
  }).observe(kdMinibarRoot, { childList: true, subtree: true, characterData: true });
}

// 27 Sep 2026: once a shirt is in the basket this pill is pinned bottom-right on phones, exactly where the
// product page's Add to cart button sits when you scroll to it, so a second shirt could not be added (a
// customer adding two kids kits got stuck). Step the pill out of the way while the real Add to cart button
// is on screen; it comes back as soon as the button scrolls off. Measured on scroll, not observed, so a
// morph that replaces the button can't leave a stale observer behind.
(function kdMinibarYield() {
  const css = document.createElement('style');
  css.textContent = '.kd-minibar{transition:opacity .18s ease,transform .18s ease}html.kd-atc-onscreen .kd-minibar{opacity:0;transform:translateY(14px);pointer-events:none}';
  document.head.appendChild(css);
  let raf = 0;
  const check = () => {
    raf = 0;
    let on = false;
    for (const b of document.querySelectorAll('form[action*="/cart/add"] button[type="submit"], form[action*="/cart/add"] button[name="add"]')) {
      if (b.closest('.sticky-add-to-cart__bar')) continue;
      const r = b.getBoundingClientRect();
      if (r.height && r.bottom > 0 && r.top < window.innerHeight) { on = true; break; }
    }
    document.documentElement.classList.toggle('kd-atc-onscreen', on);
  };
  const queue = () => { if (!raf) raf = requestAnimationFrame(check); };
  window.addEventListener('scroll', queue, { passive: true });
  window.addEventListener('resize', queue);
  document.addEventListener('cart:update', queue);
  queue();
})();
